module.exports = __webpack_public_path__ + "img/deleted.569e424e.svg";